import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { Rewards } from 'src/models/rewards/Rewards';
import { RootStore } from './RootStore';

export default class RewardsStore {
  private storeName = STORE_NAME.REWARDS_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;
  rewards?: Rewards;

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  loadRewards = async (): Promise<Rewards | undefined> => {
    try {
      const rewards = await this.apiService.getRewards();

      if (rewards) {
        runInAction(() => {
          this.rewards = rewards;
        });
      }

      return this.rewards;
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };
}
